import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9963 8.81854 22.7308 5.76844 20.4812 3.51881C18.2316 1.26918 15.1815 0.00370522 12 0ZM12 4C13.4236 4.00726 14.8188 4.39907 16.038 5.134L5.134 16.038C4.39908 14.8188 4.00727 13.4236 4 12C4.00265 9.87908 4.84636 7.84578 6.34607 6.34607C7.84579 4.84635 9.87908 4.00265 12 4ZM12 20C10.5764 19.9927 9.18124 19.6009 7.962 18.866L18.866 7.962C19.6009 9.18124 19.9927 10.5764 20 12C19.9974 14.1209 19.1536 16.1542 17.6539 17.6539C16.1542 19.1536 14.1209 19.9974 12 20Z",
      fill: "white"
    }, null, -1)
  ])))
}
export default { render: render }